$switch-background1:'#182A38' !default;
$switch-background2:'#2A475B' !default;
$switch-border:'#22303F' !default;
$switch-block1-color:'#212F3E' !default;
$switch-background-color:'#17232E' !default;
$switch-block2-color:'#B6CFE2' !default;


.switch {
  .block1{
    border: 2px solid #{$switch-border};
    .btn-custom{
      background-color: #{$switch-background-color};
      color: #{$switch-block1-color};
    }
  }
  .block2{
    border: 2px solid #{$switch-border};
    .button-off{
      background: linear-gradient( 0deg,#{$switch-background1}, #{$switch-background2});
      color: #{$switch-block2-color};
    }
    .button-on{
      background: linear-gradient( 0deg,#{$switch-background1}, #{$switch-background2});
      color: #{$switch-block2-color};
    }
  }

}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/switch/switch-theme.scss